import LoadState from './schema/LoadState';
import ProofingConfigState from './schema/ProofingConfigState';
import { EditorServiceModels } from '@editor/client-rest-api';
import { ObservableMap } from 'mobx';
import CritiqueTypeDefinition from './schema/CritiqueTypeDefinition';
import { createStore } from 'satcheljs';

export default createStore<ProofingConfigState>('proofingConfig', {
    // Default options from Editor Config service
    defaultOptionsUI: new ObservableMap<string, CritiqueTypeDefinition>(),
    defaultOptionsEditor: new ObservableMap<string, CritiqueTypeDefinition>(),
    optionsLoadState: LoadState.NotLoaded,
    critiqueTypeCategoryNames: new ObservableMap<string, string>(),

    // User options from OWS'
    userOptions: {
        overriddenOptions: new ObservableMap<string, EditorServiceModels.CritiqueTypeOption>(),
        overriddenCategories: new ObservableMap<string, boolean>(),
        spellCheckEnabled: undefined,
        grammarEnabled: undefined,
        proofingLocale: undefined,
        textPredictionEnabled: undefined,
        writingRefinementsEnabled: undefined,
        finalDatePremiumDemo: undefined,
    },

    // Dialog view state
    settingsDialogViewState: {
        overriddenOptions: new ObservableMap<string, EditorServiceModels.CritiqueTypeOption>(),
        overriddenCategories: new ObservableMap<string, boolean>(),
        spellCheckEnabled: undefined,
        grammarEnabled: undefined,
        proofingLocale: undefined,
        textPredictionEnabled: undefined,
        writingRefinementsEnabled: undefined,
        finalDatePremiumDemo: undefined,
    },

    premiumTemporarilyEnabled: false,
});
